import { lazy, Suspense } from 'react';
import { Trans } from 'react-i18next';

import { useAppTranslation } from 'hooks/use-translates';

import styles from './forgot-password-final-screen.module.scss';

const Button = lazy(() => import('core/generic/elements/button'));

type FinalScreenProps = {
	supportUrl?: string;
	supportName?: string;
	returnUrl: string;
};

export const FinalScreen = ({
	supportUrl = '',
	supportName = '',
	returnUrl,
}: FinalScreenProps) => {
	const { t } = useAppTranslation({ supportName, supportUrl });

	return (
		<>
			<div className={styles['intro-wrapper']}>
				<p className="body-medium bold">
					{t('forgot.forgot_confirmation_intro')}
				</p>

				<p className={`body-small ${styles['intro-wrapper__message']}`}>
					<Trans
						i18nKey={t('forgot.forgot_confirmation_error_ec56')}
						components={[
							<Button
								type="button"
								variant="link"
								className={styles['inline-button']}
							/>,
						]}
					/>
				</p>
			</div>

			<Button
				label={t('forgot.forgot_confirmation_button')}
				variant="primary"
				href={returnUrl}
				dimension="large"
				fullWidth={true}
				className={styles.submitButton}
			/>
		</>
	);
};

export default FinalScreen;
